"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unauthorized = void 0;
const ResponseError_1 = require("./ResponseError");
class Unauthorized extends ResponseError_1.ResponseError {
    constructor(options) {
        super(options);
        this.name = this.constructor.name;
        this.message = this.message || Unauthorized.type;
        this.type = Unauthorized.type;
        this.statusCode = Unauthorized.statusCode;
        Error.captureStackTrace(this, Unauthorized);
    }
}
exports.Unauthorized = Unauthorized;
Unauthorized.type = 'Unauthorized';
Unauthorized.statusCode = 401;
//# sourceMappingURL=Unauthorized.js.map